module.exports = __webpack_public_path__ + "static/img/s115.72d974e6.png";